import React, { ReactElement, useEffect, useState } from "react";
import { FormattedDate, FormattedMessage, useIntl } from "react-intl";

import Divider from "@mui/material/Divider";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { getMonthlyExpires } from "redux/handlers/userHandler";

import { useAppDispatch } from "hooks/reduxHook";

import { IServiceExpireAPI } from "types/api/userApiInterface";

const ExpireBox = (): ReactElement => {
 const intl = useIntl();
 const dispatch = useAppDispatch();

 const [services, setServices] = useState<Array<IServiceExpireAPI>>([]);

 useEffect(() => {
  (async () => {
   setServices(await dispatch(getMonthlyExpires()));
  })();
 }, []);

 const handleSumPrice = (): number => {
  const priceArray = services.map((element) => {
   return Number(element.amount);
  });
  const initialValue = 0;
  return priceArray.reduce((accumulator, currentValue) => accumulator + currentValue, initialValue);
 };

 return (
  <Paper elevation={1} sx={{ mt: 3, p: 2, borderRadius: "5px" }}>
   <Stack spacing={1}>
    <Typography
     textAlign="left"
     variant="unboundedTitle"
     fontWeight="bold"
     textTransform="uppercase">
     <FormattedMessage id="app.serviceExpiring" />
    </Typography>
    <Stack textAlign="left">
     <Typography variant="subtitle2">{`${intl.formatMessage({
      id: "app.totalServiceRenew"
     })}: ${handleSumPrice().toFixed(2)}€`}</Typography>
    </Stack>
    <Stack>
     {services.length === 0 ? (
      <Typography variant="caption" fontStyle="italic" sx={{ opacity: "0.5" }}>
       <FormattedMessage id="app.noServiceExpiring" />
      </Typography>
     ) : (
      services.map((service, index) => {
       return (
        <Stack key={`notification-dropdown-${index}`}>
         <Stack>
          <Stack sx={{ width: "100%" }}>
           <Stack direction="row" spacing={2} justifyContent="space-between">
            <Stack alignItems="flex-start">
             <Typography textAlign="start" variant="subtitle2">
              {service.name}
             </Typography>
            </Stack>
           </Stack>
           <Stack direction="row" justifyContent="space-between">
            <Stack direction="row" spacing={1} alignItems="center">
             <Typography variant="caption">{`${service.amount}€`}</Typography>
            </Stack>
            <Typography variant="caption" color="kxOrange">
             <FormattedDate value={service.expire} />
            </Typography>
           </Stack>
          </Stack>
          <Divider />
         </Stack>
        </Stack>
       );
      })
     )}
    </Stack>
   </Stack>
  </Paper>
 );
};

export default ExpireBox;
